import * as React from 'react';

import RotatingArrows16 from './RotatingArrows16';

export const rotatingArrows16 = () => <RotatingArrows16 />;

export default {
    title: 'Icon|Line|RotatingArrows16',
    component: RotatingArrows16,
    parameters: {
        notes: "`import RotatingArrows16 from 'box-ui-elements/es/icon/line/RotatingArrows16';`",
    },
};
